import React, {Fragment} from 'react';
import { TextField } from "@material-ui/core"
import { regexConstants } from '../../constants/regEx'
const NumberFilter = ({filter, filterOption, filterMenu, keyParam, onFieldChange,type=''}) => {
    const check = (e) => {
        if (type === 'number') return regexConstants.onlyNumeric.test(e.target.value);
        else return regexConstants.numberWithDot.test(e.target.value);
    }
    return(
        <Fragment>
            <TextField
                id={keyParam}
                label={filterMenu[keyParam].title}
                fullWidth
                margin="normal"
                value={ filterOption[keyParam] ? filterOption[keyParam] : ""}
                onChange={(e) => {check(e) ? onFieldChange(keyParam, e.target.value):e.preventDefault()}}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
            />
        </Fragment>
    )
}
export default NumberFilter;